// extracted by mini-css-extract-plugin
module.exports = {"o1wium87":"o1wium87"};